// @flow
/* eslint-disable import/max-dependencies */
import {
  call,
  select,
  put,
  debounce,
} from "redux-saga/effects";
import type { Saga } from "redux-saga";
import {
  getTablePage,
  getTablePageSize,
  getTableFilters,
} from "@fas/ui-framework/lib/redux/selectors/table";
import type { DataItem } from "@fas/ui-framework/lib/redux/reducers/table";
import {
  setTableData,
  changeTableItemsTotalAmount,
} from "@fas/ui-framework/lib/redux/actions/table";
import { setLoading } from "@fas/ui-framework/lib/redux/actions/loading";
import { addNotification } from "@fas/ui-framework/lib/redux/actions/notifications";

export type SagaConfig = {
  fetchMethod: ({
    page: number,
    limit: number,
    filters: { [string]: mixed },
  }) => mixed,
  tableName: string
};

export function* makeFetch({ fetchMethod, tableName }: SagaConfig): Saga<void> {
  try {
    yield put(setLoading(tableName, true));

    const page: number = yield select(getTablePage, tableName);
    const limit: number = yield select(getTablePageSize, tableName);
    const filters: { [string]: mixed } = yield select(getTableFilters, tableName);

    const {
      data,
      totalCount,
    }: { data: Array<DataItem>, totalCount: number } = yield call(fetchMethod, {
      page,
      limit,
      filters,
    });

    yield put(setTableData(tableName, data));
    yield put(changeTableItemsTotalAmount(tableName, totalCount));
  }
  catch (error) {
    yield put(addNotification({ message: error.errorMessage || "Failed to fetch table data", severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
  }
  finally {
    yield put(setLoading(tableName, false));
  }
}

export default function getTableSaga(config: SagaConfig): () => Saga<void> {
  return function* watchGetTableSaga(): Saga<void> {
    yield debounce(1000, config.tableName, makeFetch, config);
  };
}
